import { gql } from '@apollo/client';

export const FETCH_PROCESS_VARIABLE_DATA_TYPES = gql`
    query fetchProcessVariableDataTypes {
        lookup {
            processVariableDataTypes {
                name
                value
            }
        }
    }
`;
